import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { BUSINESS_API_PREFIX } from '../constants';
import { countEventService } from '../../events/countEvent';

interface Payload {
    numberOfEmployees: string | number;
    organizationId: string;
    companyName: string;
    source?: string;
}

export const UPDATE_BUSINESS_INFO_URL = `${BUSINESS_API_PREFIX}/business_info`;

export const updateBusinessProfile = async ({
    numberOfEmployees,
    organizationId,
    companyName,
    source = '',
}: Payload) => {
    const { userId } = getContext();
    const params = {
        user_id: userId,
        organization_id: organizationId,
        business_info: {
            company_name: companyName,
            number_of_employees: numberOfEmployees,
        },
    };

    try {
        const data = await axios.post(UPDATE_BUSINESS_INFO_URL, params);

        countEventService({ metric: 'update_business_profile', status: 'success', source });

        return data;
    } catch (error) {
        logger.error(error as any, { flow: 'updateBusinessProfile' });
        countEventService({ metric: 'update_business_profile', status: 'fail', source });
        throw error;
    }
};
